enum Action {
	Added = 'added',
	Removed = 'removed',
	Modified = 'modified',
}

export default Action;
